module.exports = __webpack_public_path__ + "img/international-blue.313a6129.svg";